import cryptoAES from 'crypto-js/aes';
import cryptoEncodingUtf8 from 'crypto-js/enc-utf8';
import { StorageKey, get, set } from './storage';

import CookieUtils from 'globals/cookie-preferences';

export function setEncryptedByPreferenceCookie<ValueType>(
  key: StorageKey,
  value: ValueType,
  secretKey: string,
  persist?: boolean,
) {
  return CookieUtils.checkBrowserPreferencesForCookieGroupHOF('functional')(
    () => setEncrypted(key, value, secretKey, persist),
  );
}

export function setEncrypted<ValueType>(
  key: StorageKey,
  value: ValueType,
  secretKey: string,
  persist?: boolean,
) {
  try {
    const encryptedValue = cryptoAES
      .encrypt(JSON.stringify(value), secretKey)
      .toString();

    set(key, encryptedValue, persist);
  } catch (error: any) {
    // console.log(error)
  }
}
export function getDecrypted(
  key: StorageKey,
  secretKey: string,
  persist?: boolean,
) {
  try {
    const encryptedValue = get<string>(key, persist);

    if (!encryptedValue) {
      return null;
    }

    const decryptedData = cryptoAES.decrypt(encryptedValue, secretKey);

    return JSON.parse(decryptedData.toString(cryptoEncodingUtf8));
  } catch (error: any) {
    return null;
  }
}
